import { render, staticRenderFns } from "./GroupAdminListContent.vue?vue&type=template&id=5e9e7c10&scoped=true"
import script from "./GroupAdminListContent.vue?vue&type=script&lang=js"
export * from "./GroupAdminListContent.vue?vue&type=script&lang=js"
import style0 from "./GroupAdminListContent.vue?vue&type=style&index=0&id=5e9e7c10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9e7c10",
  null
  
)

export default component.exports